import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Icon } from '~/components';
import type { ArtistDetails, AssetFamily } from '~/modules/artist-roster/types';

interface GiveBenchmarkFeedbackProps {
  artistData?: ArtistDetails;
  trackData?: AssetFamily;
}

export function GiveBenchmarkFeedback({
  artistData,
  trackData,
}: GiveBenchmarkFeedbackProps) {
  const { t } = useTranslation('roster');

  const [isHovered, setIsHovered] = useState(false);

  const feedbackFormLink = useMemo(() => {
    if (!trackData || !artistData) {
      return;
    }

    const { firstWeekStreams = '--', secondWeekStreams = '--' } =
      trackData.benchmark || {};

    const id = trackData.id;
    const artistAndTrackName = encodeURIComponent(
      `${artistData.name} - ${trackData.title}`,
    );

    return `https://docs.google.com/forms/d/e/1FAIpQLSfvZYvC0xKofN9kavgmSLsu3hAX8Rl2XduIE5GUsVSep-QvWg/viewform?usp=pp_url&entry.1328907116=${artistAndTrackName}&entry.1887307903=${id}&entry.2062332651=${firstWeekStreams}&entry.1952744564=${secondWeekStreams}`;
  }, [trackData, artistData]);

  if (!feedbackFormLink) {
    return null;
  }

  return (
    <Link
      aria-label={t('preReleases.tooltips.benchmarkFeedback')}
      className="flex w-full items-center justify-between gap-xl px-md py-sm transition-colors first:rounded-t-sm last:rounded-b-sm hover:bg-emphasis-default"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      to={feedbackFormLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <>
        <span>{t('preReleases.tooltips.benchmarkFeedback')}</span>
        <Icon
          type="comment-lines"
          variant={isHovered ? 'solid' : 'regular'}
          size="sm"
        />
      </>
    </Link>
  );
}

GiveBenchmarkFeedback.displayName = 'GiveBenchmarkFeedback';
